import moment from "moment";
import SecondaryBtn from "../../common/form/SecondaryBtn";
import { Applied, Apply, DotsLine, FileSave } from "../../common/svg/AllSvg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { dataActions } from "../../../shared/store/data-Slice";
import { useTranslation } from "react-i18next";

const ApplyNowCard = ({ data, job }: any) => {
    const isLogin: boolean = useSelector((state: any) => state.auth.isLogin);
    const { t } = useTranslation('common');
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();

    return (
        <div className="flex items-center justify-center w-full mt-[-55px] lg:mt-[-97px] z-[1] container">
            <div className="!w-[1100px] xlx:!w-[1250px] border border-[#E5E5E5] dark:border-[#454545] rounded-[10px] bg-white dark:bg-bgDarkDull p-[15px] sm:p-[25px] lg:py-[29px] lg:px-[46px] flex flex-col gap-[15px] md:gap-[19px]">
                <div className="w-full flex justify-between items-start md:flex-row flex-col gap-[15px]">
                    <div className="flex gap-[18px]">
                        <div style={{ backgroundColor: `${job?.department_details?.bg_color}` }} className="xlx:min-w-[100px] xlx:h-[100px] min-w-[85px] h-[85px] flex items-center justify-center rounded-[8px]">
                            <img src={job?.department_details?.icon?.aws_file_url} alt="icon" className="w-[45px]" />
                        </div>

                        <div className="flex flex-col gap-[5px]">
                            <h6 className="text-blackDull dark:text-textBlackDull font-medium">{job?.department_details?.name}</h6>
                            <h4 className="text-primaryText dark:text-white font-bold ">{job?.job_role}</h4>
                            <div className="flex gap-[8px] flex-wrap">
                                <h6 className="text-danger dark:text-darkDanger font-medium whitespace-nowrap">{t("recruitment.home.job_list.emp")} :</h6>
                                <div className="flex items-center gap-[8px] flex-wrap">
                                    {Array?.isArray(job?.employment_nature_detail) && job?.employment_nature_detail?.map((item: any, index: number) => (
                                        <div key={index} className="bg-[#F1F1F1] dark:bg-[#d4d5d838] rounded-[20px] px-[11px] py-[0.5px] flex items-center justify-center w-fit text-blackDull dark:text-textBlackDull font-semibold text-[0.813rem]">
                                            {item?.title}
                                        </div>
                                    ))}
                                </div>

                            </div>
                            <h6 className="text-danger dark:text-darkDanger font-medium"> {t("recruitment.home.ads_list.last_date")} : <span className="text-blackDark dark:text-textBlackDark"> {moment(data?.last_date_submission).format('MMM DD, YYYY')}</span></h6>
                        </div>
                    </div>

                    <div className="flex items-center gap-[8px] md:gap-[10px] md:w-auto w-full justify-end">
                        {!job?.offline && <>
                            {job?.applied_details ?
                                <div className="border border-opacity-[0.2] border-primary h-[35px] xlx:h-[40px] flex items-center gap-[8px] xlx:gap-[10px] px-[13px] xlx:px-[26px] bg-white text-primary uppercase font-extrabold rounded-[3px]">
                                    <Applied />
                                    {t("recruitment.home.applied")}
                                </div>
                                :
                                <SecondaryBtn title={t("recruitment.home.apply_now")} css="px-[13px] uppercase font-bold" leftIcon={<Apply />} onClick={() => { if (!isLogin) { dispatch(dataActions.setLoginOpen(true)) } else { !!params?.lang ? navigate(`/${params?.lang}/apply/${params?.jobId}`) : navigate(`/apply/${params?.jobId}`); dispatch(dataActions.setApplyData(null)) } }} />
                            }
                        </>}

                        <Link to={data?.attach_pdf_details?.aws_file_url} download={true} target="_blank">
                            <SecondaryBtn css="min-w-[35px] xlx:min-w-[40px]" leftIcon={<FileSave />} tabIndex={-1} titleName={t("aria_label.detail_ad")} aria-label={t("aria_label.detail_ad")} />
                        </Link>
                    </div>
                </div>

                <div className="w-full overflow-hidden">
                    <DotsLine />
                </div>

                <div className="flex gap-y-[15px] gap-x-[32px] flex-wrap">
                    <div className="flex flex-col gap-[2px] xlx:gap-[4px]">
                        <h6 className="text-blackDull dark:text-textBlackDull font-medium">  {t("recruitment.home.ads_list.add_no")}</h6>
                        <h6 className="text-primaryText dark:text-white font-semibold">{data?.adv_no}</h6>
                    </div>

                    <div className="flex flex-col gap-[2px] xlx:gap-[4px]">
                        <h6 className="text-blackDull dark:text-textBlackDull font-medium"> {t("recruitment.home.job_list.pay_scale")}</h6>
                        <h6 className="text-primaryText dark:text-white font-semibold"> {job?.salary_type === "government" ? job?.grade_pay_details?.pay_scale : `₹ ${job?.annual_ctc}`} </h6>
                    </div>

                    <div className="flex flex-col gap-[2px] xlx:gap-[4px]">
                        <h6 className="text-blackDull dark:text-textBlackDull font-medium"> {t("recruitment.home.job_list.grade")} </h6>
                        <h6 className="text-primaryText dark:text-white font-semibold"> {!!job?.grade_pay_details?.grade_code ? job?.grade_pay_details?.grade_code : "-"}</h6>
                    </div>

                    <div className="flex flex-col gap-[2px] xlx:gap-[4px]">
                        <h6 className="text-blackDull dark:text-textBlackDull font-medium">{t("recruitment.home.job_list.category")}</h6>
                        <div className="flex items-start gap-[3px] whitespace-nowrap">
                            {(Array.isArray(job?.post_category_detail) && job?.post_category_detail?.map((i: any, idx: number) =>
                                <h6 className="text-primaryText dark:text-white font-semibold whitespace-nowrap" key={idx}>
                                    {(i?.category) + " - " + (i?.post_available) + `${job?.post_category_detail?.length !== idx + 1 ? ' | ' : ' '}`}
                                </h6>
                            ))}
                        </div>
                    </div>

                    <div className="flex flex-col gap-[2px] xlx:gap-[4px]">
                        <h6 className="text-blackDull dark:text-textBlackDull font-medium">{t("recruitment.home.job_list.age")}</h6>
                        <h6 className="text-primaryText dark:text-white font-semibold">{t("recruitment.home.job_list.maximum")} {job?.rule_details?.age} {t("recruitment.home.job_list.years")}</h6>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ApplyNowCard;